import React from 'react';

import styles from './weekdayHeaders.scss';

interface WeekdayHeadersProps {
  weekdayHeaders?: unknown[];
}

export default function WeekdayHeaders({ weekdayHeaders = Array(7) }: WeekdayHeadersProps) {
  const sevenWeekdayHeaders = [];
  for (let weekday = 0; weekday <= 6; weekday++) {
    sevenWeekdayHeaders.push(
      <th key={weekday} className={styles.weekdayLabel}>
        {weekdayHeaders[weekday]}
      </th>
    );
  }

  return (
    <tr aria-hidden className={styles.weekdayHeadersContainer}>
      {sevenWeekdayHeaders}
    </tr>
  );
}
